import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Small from 'UIComponents/elements/Small';
import Big from 'UIComponents/elements/Big';
import UICopyTextArea from 'UIComponents/input/UICopyTextArea';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { getPublicAchievementUrl } from '../../../utils/RoutingUtils';
import { CertificateBadge } from '../../achievementImages';
import { getMetadataLanguageFallback, useAchievementByTrackId, useAchievementTracks } from '..';
import { useAchievementImages } from '../../achievementImages/achievementImagesQueries';
import getLang from 'I18n/utils/getLang';
import { useAchievementStatus } from '../';

const noop = () => {};

export const EmbedAward = ({
  onCopyAwardCode = noop,
  trackId,
  language = getLang()
}) => {
  const {
    images: {
      badgeURL
    },
    imagesLoading,
    imagesError
  } = useAchievementImages({
    trackId
  });
  const {
    achievement
  } = useAchievementByTrackId(trackId.toString());
  const {
    publicId
  } = achievement || {};
  const tracks = useAchievementTracks(publicId);
  const {
    name: trackName
  } = tracks ? getMetadataLanguageFallback(tracks[0].metadata, language) : {
    name: ''
  };
  const {
    urlSlug
  } = achievement && achievement.metadata && achievement.metadata ? getMetadataLanguageFallback(achievement.metadata, language) : {
    urlSlug: ''
  };
  const {
    isPrivate
  } = useAchievementStatus(trackId.toString());
  const isNotPubliclyVisible = imagesLoading || !!imagesError || isPrivate;
  const embedCode = publicId && `<!-- Begin: HubSpot Academy - ${trackName} Badge -->\n<div class='academy-badge'>\n<a href='${window.location.href.replace(/\/academy\/\d+\/.*$/, getPublicAchievementUrl(publicId, language, urlSlug))}' title='${trackName}'>\n<img src='${badgeURL}' />\n</a>\n</div>\n<!-- End: HubSpot Academy - ${trackName} Badge -->`;
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "row",
    children: [/*#__PURE__*/_jsx(CertificateBadge, {
      trackId: trackId,
      width: 195
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Big, {
          weight: "bold",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedAward.embedBadgeTitle"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.embedBadgeToggleDescription"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UICopyTextArea, {
        buttonRowRenderer: props => {
          return /*#__PURE__*/_jsx(UICopyButton, Object.assign({}, props, {
            className: "m-left-3",
            disabled: isNotPubliclyVisible,
            hint: isNotPubliclyVisible ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.disabledCopyButtonHint"
            }) : undefined,
            onClick: onCopyAwardCode,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedAward.copyEmbed"
            })
          }));
        },
        buttonUse: "tertiary",
        className: "flex-row align-center",
        textAreaProps: {
          disabled: isNotPubliclyVisible,
          style: {
            minHeight: 40,
            maxHeight: 40,
            flex: 1
          }
        },
        use: "code",
        value: embedCode
      })]
    })]
  });
};